// extracted by mini-css-extract-plugin
export default {"component":"QmznF","tooltip":"vGNr0","price":"WXRBu"};